// recorder.service.ts
import { Injectable } from '@angular/core';
import MicRecorder from 'mic-recorder-to-mp3';

@Injectable({
  providedIn: 'root'
})
export class RecorderService {
  private recorder = new MicRecorder({ bitRate: 128 });
  private isRecording = false;

  async startRecording(): Promise<void> {
    if (this.isRecording) {
      throw new Error('Recording is already in progress.');
    }

    try {
      await this.recorder.start();
      this.isRecording = true;
    } catch (e) {
      console.error(e);
      throw e; // Allow the error to be caught by the component
    }
  }

  async stopRecording(): Promise<File> {
    // if (!this.isRecording) {
    //   throw new Error('Recorder is not running.');
    // }

    try {
      const [buffer, blob] = await this.recorder.stop().getMp3();
      this.isRecording = false;
      console.log(blob);
      return new File(buffer, 'recording.mp3', {
        type: blob.type,
        lastModified: Date.now()
      });
    } catch (e) {
      console.error(e);
      throw e; // Allow the error to be caught by the component
    }
  }
  // cancel recording
  async cancelRecording() {
    if (this.isRecording) {
      await this.recorder.stop();
      this.isRecording = false;
    }
  }

  // Methods for pause and resume would be added here when supported
}